import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AgentType } from '../models/agent-type.model';

@Injectable({
  providedIn: 'root'
})
export class AgentTypesService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/api/types`;
  
  getAgentTypes(): Observable<AgentType[]> {
    const url = `${this.apiUrl}?sort_by=id&sort_order=asc`;
    return this.http.get<any>(url).pipe(
      map(response => response.data.data),
      catchError((error) => {
        console.error('[AgentTypesService] GET request failed', error);
        return throwError(() => error);
      })
    );
  }

  updateAgentType(id: number, transcription_active: boolean): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, { transcription_active }).pipe(
      catchError((error) => {
        console.error('[AgentTypesService] PUT request failed', error);
        return throwError(() => error);
      })
    );
  }
}
